<head>

<script src="https://unpkg.com/vue"></script>
</head>
<template>
  <br />
  <div class="row" style="margin-bottom: 10px">
    <span class="page-title">Disponibilizar de Agenda</span>
  </div>

  <div class="row">
    <div class="col-xs-12 col-sm-12 col-md-6 col-lg-4 col-xl-4">
      <label for="cpf">CPF</label><br />
      <input type="text" class="form-control form-input-component" v-mask="'###.###.###-##'" ref="cpf" v-model="dataUser.cpf" id="cpf" readonly disabled />
    </div>

    <div class="col-xs-12 col-sm-12 col-md-6 col-lg-4 col-xl-4">
      <label for="nome">Nome</label><br />
      <input type="text" class="form-control form-input-component" v-model="dataUser.nome" id="nome" readonly disabled />
    </div>

    <div class="col-xs-12 col-sm-12 col-md-12 col-lg-4 col-xl-4">
      <label>Especialidade</label><br />
      <input type="text" class="form-control form-input-component" v-model="profissional.especialidade.nome" readonly disabled />
    </div>
  </div>
  <br />

  <form class="row needs-validation" novalidate id="frmAgenda">
    <div class="row">
      <div class="col-xs-12 col-sm-12 col-md-6 col-lg-4 col-xl-2">
        <label for="diaSemana">Dia da Semana</label>
        <select class="form-select" v-model="form.diaSemana" required v-bind:class="{ 'is-invalid': submitted && !form.diaSemana }">
          <option value="DOMINGO">Domingo</option>
          <option value="SEGUNDA">Segunda-feira</option>
          <option value="TERCA">Terça-feira</option>
          <option value="QUARTA">Quarta-feira</option>
          <option value="QUINTA">Quinta-feira</option>
          <option value="SEXTA">Sexta-feira</option>
          <option value="SABADO">Sábado</option>
        </select>
      </div>

      <div class="col-xs-12 col-sm-12 col-md-6 col-lg-4 col-xl-2">
        <label for="horaInicio">Hora de início</label>
        <input type="text" v-model="form.horaInicio" v-mask="'##:##'" required v-bind:class="{ 'is-invalid': submitted && !form.horaInicio }" class="form-control form-input-component form-input-component" id="horaInicio" />
      </div>

      <div class="col-xs-12 col-sm-12 col-md-6 col-lg-4 col-xl-2">
        <label for="horaFim">Hora final</label>
        <input type="text" v-model="form.horaFim" v-mask="'##:##'" required v-bind:class="{ 'is-invalid': submitted && !form.horaFim }" class="form-control form-input-component form-input-component" id="horaFim" />
      </div>

      <div class="col-xs-12 col-sm-12 col-md-6 col-lg-4 col-xl-2">
        <label for="tipoAgenda">Tipo Agenda</label>
        <select class="form-select" v-model="form.tipoAgenda" required v-bind:class="{ 'is-invalid': submitted && !form.tipoAgenda }">
          <option>PRESENCIAL</option>
          <option>VIRTUAL</option>
        </select>
      </div>

      <div class="col-xs-12 col-sm-12 col-md-12 col-lg-8 col-xl-4">
        <label for="unidadeAtendimento">Unidade Atendimento</label>
        <select class="form-select" v-model="form.unidadeAtendimento">
          <option v-for="item in listaUnidade" :key="item.id" :value="item.unidadeNome">
            {{ item.unidadeNome }}
          </option>
        </select>
      </div>
    </div>

    <div class="row">
      <div class="col-3">
        &nbsp;<br />
        <button type="button" class="btn btn-primary" @click="saveAndContinue(v$.form.$invalid, true)">Salvar</button>
      </div>
    </div>
  </form>
  <br />
  <a-table :dataSource="listaAlocacoesAgenda" :columns="columns" :key="id">
    <template #action="{ record }">
      <a @click="excluir(record)" alt="Excluir"> <i class="fas fa-trash-can icon-trash-can"></i></a>
    </template>
    <!--
        <template #unidade="{ record }">
            <a-popconfirm
                v-if="dataSource.length"
                title="Confirma exclusão ?"
                @confirm="onDelete(record.key)">
                <a>Delete</a>
            </a-popconfirm>
        </template>
        -->
  </a-table>

  <!--
    <div style="height: max-content">
      <vue-cal
          class="vuecal--full-height-delete vuecal--blue-theme "
          locale="pt-br"
          hide-view-selector
          :time-from="6*60"
          :timeTo="20*60"
          :disable-views="['years','year','month','day']"
          :hide-weekdays="[]"
          :editable-events="{title: false, create : true, delete: true, resize: true, drag: false, drag: true}"
          :resizeX="true"
          :snapToTime="60"
          :dragToCreateEvent='true'
          :minDate="new Date()"
          :on-event-create="onEventCreate"

      />
    </div>

  -->
</template>

<script>
import { getDataUser } from '@/utils';
import { getProfissionalByCpf } from '@/components/service/profissionalService';
import { required } from '@vuelidate/validators';
import { openNotification, typesNotification } from '@/utils/notifications';
import { useVuelidate } from '@vuelidate/core';
import { alocarAgenda, getAgendaAlocacoes, excluir } from '@/components/service/agenda';
import { getUnidadesTrabalho } from '@/config/servicos-utils';

export default {
  name: 'PageDisponibilizarAgenda',
  setup() {
    return { v$: useVuelidate() };
  },
  data() {
    return {
      listaAlocacoesAgenda: [],
      listaUnidade: [],
      dataUser: getDataUser(),
      profissional: undefined,
      form: {
        cpfProfissional: undefined,
        diaSemana: undefined,
        horaInicio: undefined,
        horaFim: undefined,
        tipoAgenda: undefined,
        unidadeAtendimento: undefined,
      },
      columns: [
        {
          title: 'Dia da Semana',
          dataIndex: 'diaSemana',
          key: 'diaSemana',
        },
        {
          title: 'Hora Início',
          dataIndex: 'horaInicio',
          key: 'horaInicio',
        },
        {
          title: 'Hora Fim',
          dataIndex: 'horaFim',
          key: 'horaFim',
        },
        {
          title: 'Tipo de Agenda',
          dataIndex: 'tipoAgenda',
          key: 'tipoAgenda',
        },
        {
          title: 'Unidade de Atendimento',
          dataIndex: 'unidadeAtendimento',
          key: 'unidadeAtendimento',
        },
        {
          title: 'Ações',
          dataIndex: 'action',
          key: 'action',
          slots: { customRender: 'action' },
        },
      ],
    };
  },
  validations() {
    return {
      form: {
        diaSemana: {
          required,
        },
        horaInicio: {
          required,
        },
        horaFim: {
          required,
        },
        tipoAgenda: {
          required,
        },
      },
    };
  },
  methods: {
    async excluir(rec) {
      await excluir(rec.id)
        .then(() => {
          openNotification(typesNotification.success, 'Exclusão efetuada com sucesso!');
          this.atualizarTabela();
        })
        .catch(function (error) {
          if (error.response) {
            console.log(error.response.data);
            console.log(error.response.status);
            console.log(error.response.headers);
          } else if (error.request) {
            console.log(error.request);
          } else {
            console.log('Error', error.message);
          }
          openNotification(typesNotification.error, 'Falha na exclusão de Alocação da Agenda!');
        });
    },
    atualizarTabela() {
      getAgendaAlocacoes(this.profissional.cpf).then((rs) => {
        this.listaAlocacoesAgenda = rs.data;
      });
    },
    recuperarProfissionalLogado() {
      getProfissionalByCpf(this.dataUser.cpf)
        .then((r) => {
          this.profissional = r.data;
          this.atualizarTabela();
        })
        .catch(() => {
          openNotification(typesNotification.error, 'Usuário não cadastrado como Profissional de Saúde!');
        });
    },
    // eslint-disable-next-line no-unused-vars
    async saveAndContinue(invalid, back) {
      if (invalid) {
        openNotification(typesNotification.error, 'Informe os campos obrigatórios');
      } else {
        this.form.cpfProfissional = this.profissional.cpf;
        await alocarAgenda(this.form).then(() => {
          openNotification(typesNotification.success, 'Dados salvos com sucesso.');
          // recarregar lista aqui
          this.atualizarTabela();
        });
        this.form.horaInicio = '';
        this.form.horaFim = '';
      }
    },
  },
  created() {
    this.recuperarProfissionalLogado();
    getUnidadesTrabalho(this.dataUser.cpf).then((rs) => {
      this.listaUnidade = rs.data;
    });
  },
};
</script>

<style>
.input-group-text {
  height: 38px;
}

.input-group-prepend {
  cursor: pointer;
  margin-left: 8px !important;
}

.input-group-text:hover {
  background-color: #e0e0e0 !important;
}
.h2 {
  font-size: x-large;
}
</style>
